// Each form input
import InputComponent from './Input'
import DropdownComponent from './Dropdown'

// Connects field to redux-forms
import FieldWrapper from './FieldWrapper'

// Wrap and export fields
export const Input = FieldWrapper(InputComponent)
export const Dropdown = FieldWrapper(DropdownComponent)



// WEBPACK FOOTER //
// ./src/components/Fields/index.js